(function () {
    'use strict';

    angular
        .module('core.services')
        .service('CompanyStatusService', CompanyStatusService)

    /** @ngInject */
    function CompanyStatusService(HttpService) {
        const CompanyStatusService = {
            get,
            getAll,
            getByParameters,
            post,
            put,
            migrateData,
            deleteData
        }

        return CompanyStatusService;

        function get(companyStatusId) {
            return HttpService.get(`/status/${companyStatusId}`);
        }

        function getAll() {
            return HttpService.get('/status/by-parameters', {
                params: {}
            });
        }

        function getByParameters(params) {
            return HttpService.get('/status/by-parameters', {
                params
            });
        }

        function post(companyStatusData) {
            return HttpService.post('/status', companyStatusData);
        }

        function put(companyStatusData) {
            return HttpService.put('/status', companyStatusData);
        }

        function migrateData(companyStatusOriginId, companyStatusDestinationId) {
            return HttpService.put(`/status/migrate/${companyStatusOriginId}/${companyStatusDestinationId}`);
        }

        function deleteData(companyStatusId) {
            return HttpService.delete(`/status/${companyStatusId}`);
        }
    }
}());